<div class="notification-wrapper">
  <div class="notification-header">
    @if(severity === ToastSeverity.Custom && quantity){
    <img class="mr-8-px" src="./../../../assets/images/toast/success-icon.svg" alt="success-icon">
    <h3 class="mb-unset">{{quantity}} item{{quantity > 1 ? 's' : ""}} added to
      cart</h3>
    } @else {
    @if(severity === ToastSeverity.Success){
    <img class="mr-8-px" src="./../../../assets/images/toast/success-circle-light.svg" alt="success-icon">
    } @else if(severity === ToastSeverity.Info){
    <img class="mr-8-px" src="./../../../assets/images/toast/info-light.svg" alt="info-icon">
    } @else if(severity === ToastSeverity.Error){
    <img class="mr-8-px" src="./../../../assets/images/toast/error-light.svg" alt="error-icon">
    } @else if(severity === ToastSeverity.Warning){
    <img class="mr-8-px" src="./../../../assets/images/toast/warning-light.svg" alt="warning-icon">
    }
    <h3 class="mb-unset light">{{message || summary}}</h3>
    }

  </div>
  @if((searchResult || product || productVariant)){
  <div class="selected-item mt-12-px">
    <app-product-image-wrapper>
      <div class="img-wrapper">
        @if(featuredAsset){
        <img [src]="featuredAsset | assetPreview:'thumb'" [alt]="'product-image'">
        } @else {
        <img src="./../../../assets/images/product/mock-images/no-img-placeholder.svg" [alt]=" productName || ''">
        }
      </div>
    </app-product-image-wrapper>

    <app-product-details-header 
    [name]="searchResult?.productName || productVariant?.name || product?.name"
    [slug]="searchResult?.slug|| productVariant?.product?.slug || product?.slug"
    [manufacturer]="searchResult?.customAttributes?.manufacturer  || productVariant?.product?.customAttributes?.manufacturer || product?.customAttributes?.manufacturer"
    [small]="true" 
    [showCodeAndBrandLine]="false"
    [brandAndNameInline]="true"
    [showLabels]="false"></app-product-details-header>

  </div>

  }

  @if(actions){
  <div class="actions mt-12-px">
    @if(actions.requestMore){
    <button (click)="openRequestPartDialog()" pButton pRipple class="c-button toast-action"
      [class.dark-text]="severity === ToastSeverity.Custom">Request
      more</button>
    }
    @if(actions.viewCart){
    <button (click)="openCartSidenav();" pButton pRipple class="c-button toast-action"
      [class.dark-text]="severity === ToastSeverity.Custom">View cart</button>
    }
  </div>
  }
</div>
